import React from 'react'
import { Link } from "react-router-dom"
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import links from '../nav'
import { useAuth0 } from "@auth0/auth0-react"

function GridMenu() {
  const { user, isAuthenticated } = useAuth0()
  console.log({ user })
  const isAdmin = user && user.sub === "google-oauth2|104861804208992956729"
  return (
    <Grid flex container spacing={2} mt={2} style={{ maxWidth: '100%' }}>
      <Grid item xs={12} sm={8} md={6}>
        <Card style={{ height: 200 }}>
          <CardContent>
            <Typography variant="h2" component="div">
              BLACKBURN
              <br />
              DEFENSE
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      {links.filter(link => !link.hidden && (!link.authed || isAuthenticated) && (!link.admin || isAdmin)).map((link, index) => (
        <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
          <Link to={link.url} key={index} className="link" style={{ textDecoration: 'none' }}>
            <Card style={{ height: 200 }}>
              <CardContent>
                <link.icon style={{ fontSize: 100, color: link.color }} />
                <Typography variant="h5" component="div">
                  {link.label}
                </Typography>
              </CardContent>
            </Card>
          </Link>
        </Grid>
      ))}
    </Grid>
  );
}

export default GridMenu
